import { Color4 } from '../engine/Color4';
import { Container } from '../engine/Container';
import { CgsEvent } from '../engine/Event';
import { PlatformSettings } from '../engine/PlatformSettings';
import { Rect } from '../engine/Rect';
import { SceneObject } from '../engine/SceneObject';
import { SpriteBatch } from '../engine/SpriteBatch';
import { ApplicationRender } from './ApplicationRender';
import { TemplateApplication } from './TemplateApplication';

export class ApplicationBuilder extends TemplateApplication {
  private readonly _rootScene = new SceneObject();
  private readonly _applicationRender: ApplicationRender;
  private _backgroundColor: Color4 = new Color4(0, 0, 0, 0); // Default to transparent

  constructor(
    window: Window,
    canvas: HTMLCanvasElement,
    settings: PlatformSettings,
    container: Container
  ) {
    super();

    this._applicationRender = new ApplicationRender(window, canvas, settings, container);
    this.platform = this._applicationRender.platform;
  }

  public async build(rect: Rect): Promise<void> {
    try {
      const { resourceCache } = await this._applicationRender.buildApp();

      this.buildApp(this.platform, resourceCache, rect);

      this._applicationRender.registerApplication(this);

      await this.onAppBuild();
    } catch (error) {
      this.onInitError(error);
      return;
    }

    try {
      await this.loadInitGameData();

      await this.loadResources();

      await this.loadGameData();

      this.initDeviceListeners();

      this.onAppReady();
    } catch (error) {
      this.onError(error);
    }
  }

  public async loadPackage(path: string): Promise<void> {
    await this.resourceCache.loadPackage(path);
  }

  public get rootScene(): SceneObject {
    return this._rootScene;
  }

  public updateImpl(dt: number): void {
    this.rootScene.update(dt);
  }

  public drawImpl(spriteBatch: SpriteBatch): void {
    // Clear the screen with the selected background color
    spriteBatch.clear(this._backgroundColor);

    this.rootScene.draw(spriteBatch);
  }

  public dispatchEvent(event?: CgsEvent): void {
    if (!event) {
      return;
    }
    this.rootScene.sendEvent(event);
  }

  public async onAppBuild(): Promise<void> {
    //hook for extend game (for example register extra cache's pools)
  }

  public async loadInitGameData(): Promise<void> {
    throw new Error('Method not implemented.');
  }
  public async loadResources(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  public async loadGameData(): Promise<void> {
    throw new Error('Method not implemented.');
  }

  public async onAppReady() {
    throw new Error('Method not implemented.');
  }

  public onInitError(_: unknown): void {
    throw new Error('Method not implemented.');
  }

  public onError(_: unknown): void {
    throw new Error('Method not implemented.');
  }

  public activate(_: boolean): void {
    throw new Error('Method not implemented.');
  }

  public setBackgroundColor(color: Color4): void {
    this._backgroundColor = color;
  }

  public get backgroundColor(): Color4 {
    return this._backgroundColor;
  }
}
